import Header from "../layout/header"
import Header2 from "../layout/header/Header2"
import AdmissionBanner from "../layout/header/AdmissionBanner"
import CxcAnnouncementBanner from "../layout/header/CxcAnnouncementBanner"
import AdmissionBadge from "./AdmissionBadge"
import { ReactNode } from "react"
import { Poppins } from "next/font/google"
import { usePathname } from "next/navigation";
import 'bootstrap/dist/css/bootstrap.min.css'
import Footer from "./footer";

const poppins = Poppins({
  subsets: ["latin"],
  weight: ["400", "500", "600", "700"],
})

const Layout = ({ children }: { children: ReactNode }) => {
  const pathname = usePathname();

  // Add all routes where footer should be hidden
  const hideFooterRoutes = ["/enquiryPage", "/applicationTracker"];

  const shouldHideFooter = hideFooterRoutes.includes(pathname || "");
  const isAbout2 = pathname?.startsWith("/about2");

  return (
    <>
      <div className={poppins.className}>
       <div className="headerstick">
         <AdmissionBanner />
         <CxcAnnouncementBanner />
        <Header />
        </div>
        {children}
        {!shouldHideFooter && (
          <Footer />
        )}
        <AdmissionBadge />
      </div>
    </>
  )
}

export default Layout
